import ErrorAdminNavigationPage from "./ErrorAdminNavigationPage";

export default ErrorAdminNavigationPage;
